import { c as _c } from "react/compiler-runtime";
/* eslint-disable local-rules/require-use-client */
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
import type { SKUSelectorV2DropdownOption } from './SKUSelectorV2Props';
export interface SKUSelectorV2DropdownProps {
  dropdownOptions: SKUSelectorV2DropdownOption[] | undefined;
  activeOption: SKUSelectorV2DropdownOption | undefined;
  selectedSku: string;
  isLoading: boolean;
  onChange: (sku: string) => void;
  previewAllItems?: boolean;
}
export function SKUSelectorV2Dropdown(t0) {
  const $ = _c(22);
  const {
    dropdownOptions,
    activeOption,
    selectedSku,
    isLoading,
    onChange,
    previewAllItems: t1
  } = t0;
  const previewAllItems = t1 === undefined ? false : t1;
  const isPreview = previewAllItems && getBuilderPreviewMode().edit;
  if (isPreview) {
    let t2;
    if ($[0] !== dropdownOptions) {
      t2 = dropdownOptions?.map(_temp);
      $[0] = dropdownOptions;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2) {
      t3 = <div className="flex flex-col gap-4 border border-blue-400 px-4">{t2}</div>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t2 = activeOption?.contentTop;
  const t3 = activeOption?.content;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronUpDownIcon className="size-4" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <ListboxButton className="flex w-full items-center justify-between rounded-lg p-4 text-left outline outline-1 outline-bodi-gray-butters">{t3}{t4}</ListboxButton>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("mt-2 w-(--button-width) origin-top rounded-lg bg-bodi-white py-2 outline outline-1 outline-bodi-gray-butters drop-shadow-md", "transition duration-200 ease-out data-closed:scale-95 data-closed:opacity-0");
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== dropdownOptions || $[9] !== selectedSku) {
    t7 = dropdownOptions?.map(option_0 => <ListboxOption key={option_0.sku} value={option_0.sku} className="flex items-center gap-2 p-3 text-left hover:bg-bodi-accent-bright-300"><CheckIcon className={cn("size-5 text-transparent", option_0.sku === selectedSku && "text-bodi-accent-deep-500")} />{option_0.content}</ListboxOption>);
    $[8] = dropdownOptions;
    $[9] = selectedSku;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <ListboxOptions anchor="bottom" transition={true} className={t6}>{t7}</ListboxOptions>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isLoading || $[14] !== onChange || $[15] !== selectedSku || $[16] !== t5 || $[17] !== t8) {
    t9 = <Listbox value={selectedSku} onChange={onChange} disabled={isLoading}>{t5}{t8}</Listbox>;
    $[13] = isLoading;
    $[14] = onChange;
    $[15] = selectedSku;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t2 || $[20] !== t9) {
    t10 = <div className="flex w-full flex-col">{t2}{t9}</div>;
    $[19] = t2;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp(option) {
  return <div className="flex flex-col gap-8 border-b border-bodi-gray-butters py-4 last:border-b-0" key={option.sku}>{option.contentTop}{option.content}</div>;
}